import { useCallback } from "react";
import asyncConfirm from "~/src/utils/async-confirm";
import { errorModal } from "~/src/utils/errors";
import { BOOKING_STATES_LABELS } from "~/src/consts";

const useBookingActions = updateBookingMutation => {
  const handleStateChange = useCallback(
    async (booking, newState) => {
      const message =
        "Are you sure you want to update this booking to" +
        ` '${BOOKING_STATES_LABELS[newState]}'`;

      if (
        await asyncConfirm(message, {
          shouldHideSubText: true,
          shouldAddPadding: true,
          confirmButtonText: "Yes",
          isConfirmButtonGreen: true
        })
      ) {
        try {
          await updateBookingMutation({
            refetchQueries: ["fetchMemberBookings"],
            variables: {
              id: booking.id,
              state: newState,
              accountType: "provider"
            }
          });
        } catch (e) {
          errorModal(e);
        }
      }
    },
    [updateBookingMutation]
  );

  const handleLoadMore = useCallback(async (fetchMoreFunction, items) => {
    try {
      await fetchMoreFunction({
        variables: {
          offset: items?.length || 10
        }
      });
    } catch (e) {
      errorModal(e);
    }
  }, []);

  return { handleStateChange, handleLoadMore };
};

export default useBookingActions;
